import PropTypes from 'prop-types';
import React from 'react';
import Link from '../Link';
import Icon from '../Icon';
import * as Styled from './styles';
export default function FooterSocialItem({
  href = null,
  icon,
  ariaLabelName
}) {
  return /*#__PURE__*/React.createElement(Styled.InlineBlock, {
    className: "footer-social__item"
  }, /*#__PURE__*/React.createElement(Link, {
    "aria-label": `Follow us on ${ariaLabelName}`,
    className: "footer-social__item",
    target: "_blank",
    rel: "noopener noreferrer",
    href
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon
  })));
}
FooterSocialItem.propTypes = {
  href: PropTypes.string,
  icon: PropTypes.string.isRequired
};
//# sourceMappingURL=social-item.js.map